import * as auth from '../auth/auth';

export default auth;
